import React, { useState } from 'react';
import authService from '../services/authService';
import './Login.css';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [email, setEmail] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  const [needsVerification, setNeedsVerification] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSignIn = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const result = await authService.signIn(username, password);
      onLogin(result);
    } catch (err) {
      // If there's already a signed in user, sign them out first and try again
      if (err.name === 'UserAlreadyAuthenticatedException') {
        try {
          await authService.signOut();
          const result = await authService.signIn(username, password);
          onLogin(result);
        } catch (retryErr) {
          setError(retryErr.message || 'Sign in failed');
        }
      } else {
        setError(err.message || 'Sign in failed');
      }
    } finally {
      setLoading(false);
    }
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.signUp(username, password, email);
      setNeedsVerification(true);
      setError('');
    } catch (err) {
      setError(err.message || 'Sign up failed');
    } finally {
      setLoading(false);
    }
  };

  const handleVerify = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      await authService.verifyEmail(username, verificationCode);
      setNeedsVerification(false);
      setIsSignUp(false);
      setError('Email verified! You can now sign in.');
    } catch (err) {
      setError(err.message || 'Verification failed');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-card">
        <h1>MCP Gateway Authentication</h1>
        
        {error && <div className="error-message">{error}</div>}

        {needsVerification ? (
          <form onSubmit={handleVerify}>
            <h2>Verify Email</h2>
            <p>Please check your email for the verification code</p>
            <div className="form-group">
              <label>Verification Code:</label>
              <input
                type="text"
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                required
              />
            </div>
            <button type="submit" disabled={loading}>
              {loading ? 'Verifying...' : 'Verify'}
            </button>
            <button
              type="button"
              onClick={() => setNeedsVerification(false)}
              className="secondary-button"
            >
              Back
            </button>
          </form>
        ) : (
          <>
            <div className="auth-tabs">
              <button
                className={!isSignUp ? 'active' : ''}
                onClick={() => setIsSignUp(false)}
                type="button"
              >
                Sign In
              </button>
              <button
                className={isSignUp ? 'active' : ''}
                onClick={() => setIsSignUp(true)}
                type="button"
              >
                Sign Up
              </button>
            </div>

            {isSignUp ? (
              <form onSubmit={handleSignUp}>
                <div className="form-group">
                  <label>Username:</label>
                  <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Email:</label>
                  <input
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Password:</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                    minLength={8}
                  />
                  <small>
                    Password must be at least 8 characters with uppercase, lowercase, and numbers
                  </small>
                </div>
                <button type="submit" disabled={loading}>
                  {loading ? 'Signing Up...' : 'Sign Up'}
                </button>
              </form>
            ) : (
              <form onSubmit={handleSignIn}>
                <div className="form-group">
                  <label>Username:</label>
                  <input
                    type="text"
                    value={username}
                    onChange={(e) => setUsername(e.target.value)}
                    required
                  />
                </div>
                <div className="form-group">
                  <label>Password:</label>
                  <input
                    type="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                <button type="submit" disabled={loading}>
                  {loading ? 'Signing In...' : 'Sign In'}
                </button>
              </form>
            )}
          </>
        )}
      </div>
    </div>
  );
}

export default Login;
